import { FC } from 'react'

export interface ProcessBadgeProps {
  label: string
}

// Process/Tag values are open-ended (backend-driven, not a fixed enum), so the colour is derived
// deterministically from the label text rather than hardcoded per value. Only the app's saturated
// hues (green/orange/red) are used — the palette's two grey/muted tones (S, N) read as visually
// identical to each other at this dot size, so they're excluded in favour of two distinguishable
// shades per hue.
const DOT_COLORS = [
  'bg-G-500',
  'bg-P-500',
  'bg-R-500',
  'bg-G-700',
  'bg-P-700',
  'bg-R-700',
]

const colorForLabel = (label: string): string => {
  let hash = 0
  for (let i = 0; i < label.length; i++) {
    hash = (hash * 31 + label.charCodeAt(i)) | 0
  }
  return DOT_COLORS[Math.abs(hash) % DOT_COLORS.length]
}

export const ProcessBadge: FC<ProcessBadgeProps> = ({
  label,
}: ProcessBadgeProps) => {
  return (
    <span className='inline-flex items-center gap-[6px] text-[11.5px] font-semibold text-N-600 bg-N-50 border border-N-100 rounded-full px-[10px] py-[3px]'>
      <span
        className={`w-[7px] h-[7px] rounded-full ${colorForLabel(
          label,
        )}`}></span>
      {label}
    </span>
  )
}

export default ProcessBadge
